module.exports = __webpack_public_path__ + "static/img/f.eb04d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f.png
// module id = 2YIi
// module chunks = 1